var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "crown",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 204.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "crown") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.63,201.19a10.54,10.54,0,0,0,4.31-.92l0,.08,0,0S79.6,245.59,92.67,302.21c15.8-10.35,57.89-17.76,107.33-17.76s91.53,7.41,107.33,17.76C320.4,245.59,360,200.32,360,200.32l0,0,0-.08A10.66,10.66,0,1,0,358,199c-4,5.14-8.15,10-12.35,14.51-20,20.77-33.17,22.05-41,16.37s-12.27-20.31-8.47-46.71c1.3-8.26,3.22-17.19,5.64-26.45a13.93,13.93,0,1,0-2.67-.94c-18.36,37.1-38.31,60.17-56.62,59.44-19.79-.8-31.34-36.67-40.27-85.47a16.07,16.07,0,1,0-4.4,0c-8.93,48.8-20.48,84.67-40.27,85.47-18.31.73-38.26-22.34-56.62-59.44a14.16,14.16,0,1,0-2.67.94c2.41,9.27,4.34,18.19,5.64,26.45,3.8,26.4-.63,41-8.47,46.71s-21,4.4-41-16.37c-4.21-4.5-8.33-9.37-12.35-14.51a10.62,10.62,0,1,0-6.42,2.17Z",
    transform: "translate(-25 -97.79)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.c53fe8bbd21dae88eebf101f7095ea7b.svg";
export { ForwardRef as ReactComponent };